import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Button } from '@aimsos/ui';

import { Folder, HardDrive } from 'lucide-react';

/**
 * "THIS RECORD": the drive and its folders, as in the prototype (CT-5717). Each
 * entry opens that folder; the one in view is marked `aria-current`.
 */
const DriveTree = memo(function DriveTree({ tree, currentId, onOpen }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <nav aria-label={t('knowledge.drive.tree.ariaLabel')} data-testid="drive-tree" className="flex flex-col gap-1">
      <span className="px-2 text-xs font-semibold uppercase tracking-wide text-content-muted">{t('knowledge.drive.tree.title')}</span>
      {tree.map((node) => (
        <Button
          key={node.id}
          variant="ghost"
          size="sm"
          leftIcon={node.depth === 0 ? HardDrive : Folder}
          onClick={() => onOpen(node.id)}
          aria-current={node.id === currentId ? 'true' : undefined}
          className={['w-full !justify-between', node.depth ? 'pl-6' : '', node.id === currentId ? 'bg-surface-muted' : '']
            .filter(Boolean)
            .join(' ')}
        >
          <span className="min-w-0 truncate">{node.name}</span>
          <span className="text-xs text-content-muted">{node.fileCount}</span>
        </Button>
      ))}
    </nav>
  );
});

export default DriveTree;
